import { SignInWithProviderButtons, } from 'root/src/client/v2/auth/components/SignInWithProviderButtons';
import { ModalTitle } from 'root/src/client/v2/common/components/modal/ModalTitle';
import { ModalLayout } from '../../common/layouts/ModalLayout';
export function SignInWithProvidersModal(props) {
    return (<ModalLayout>
			<ModalTitle>{props.title || 'Connect Channels'}</ModalTitle>
			<SignInWithProviderButtons isLinking popup={props.popup} popupOptions={props.popupOptions} className="flex flex-col w-[280px] gap-3"/>
		</ModalLayout>);
}
